//eslint-disable-next-line import/prefer-default-export
export const INSTANT_QUOTE_TYPES = {
  LONG_GRASS: 'instant_quote_long_grass',
};

export const INSTANT_QUOTE_STATUS = {
  CONTRACTOR_NEW: 'contractor.new',
  CUSTOMER_PENDING: 'customer.pending',
  CUSTOMER_ACCEPTED: 'customer.accepted',
  CUSTOMER_REJECTED: 'customer.rejected',
  CANCELLED: 'cancelled',
};
